<script>
    import CheckCircle from "../icons/CheckCircle.svelte";
    import ChevronDownIcon from "../icons/ChevronDownIcon.svelte";
    import ChevronUpIcon from "../icons/ChevronUpIcon.svelte";
    import ChevronRightIcon from "../icons/ChevronRightIcon.svelte";
    import MehIcon from "../icons/MehIcon.svelte";
    import SadIcon from "../icons/SadIcon.svelte";
    import SearchIcon from "../icons/SearchIcon.svelte";
    import SmileIcon from "../icons/SmileIcon.svelte";
    import VectorIcon from "../icons/VectorIcon.svelte";

    export let name = "icon";
    export let size = 16;
    export let strokeWidth = 2;
    export let color = "currentColor";
    export let className = "";
</script>

{#if name === 'check-circle'}<CheckCircle />
{:else if name === 'chevron-up'}<ChevronUpIcon />
{:else if name === 'chevron-down'}<ChevronDownIcon />
{:else if name === 'chevron-right'}<ChevronRightIcon />
{:else if name === 'meh'}<MehIcon />
{:else if name === 'sad'}<SadIcon />
{:else if name === 'search'}<SearchIcon />
{:else if name === 'smile'}<SmileIcon />
{:else if name === 'vector'}<VectorIcon />
{:else}
    <svg
        class="icon-inline {className}"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        stroke-width={strokeWidth}
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        {#if name === 'x' || name === 'close'}
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        {:else if name === 'check'}
            <polyline points="20 6 9 17 4 12"></polyline>
        {:else if name === 'check-check'}
            <path d="M18 6L7 17l-5-5"></path>
            <path d="M22 10l-7.5 7.5L13 16"></path>
        {:else if name === 'clock'}
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
        {:else if name === 'utensils'}
            <path d="M18 2v20"></path>
            <path d="M21 2c0 3.31-1.34 6-3 6s-3-2.69-3-6"></path>
            <path d="M3 2v8c0 1.66 1.34 3 3 3s3-1.34 3-3V2"></path>
            <path d="M6 13v9"></path>
            <line x1="6" y1="2" x2="6" y2="6"></line>
        {:else if name === 'globe'}
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
        {:else if name === 'whatsapp' || name === 'message-circle'}
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
        {:else if name === 'message-square' || name === 'chat'}
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        {:else if name === 'printer'}
            <polyline points="6 9 6 2 18 2 18 9"></polyline>
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
            <rect x="6" y="14" width="12" height="8"></rect>
        {:else if name === 'bike'}
            <circle cx="5.5" cy="17.5" r="3.5"></circle>
            <circle cx="18.5" cy="17.5" r="3.5"></circle>
            <path d="M15 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-3 11.5V14l-3-3 4-3 2 3h4"></path>
        {:else if name === 'motorcycle' || name === 'moto'}
            <circle cx="5" cy="16" r="3"></circle>
            <circle cx="19" cy="16" r="3"></circle>
            <path d="M12 16h3l3-7H8l-3 4"></path>
            <path d="M13 9l2-4h3"></path>
        {:else if name === 'car'}
            <rect x="3" y="11" width="18" height="7" rx="2"></rect>
            <path d="M5 11l2-5h10l2 5"></path>
            <circle cx="7" cy="18" r="2"></circle>
            <circle cx="17" cy="18" r="2"></circle>
        {:else if name === 'map-pin'}
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
        {:else if name === 'wallet'}
            <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4"></path>
            <path d="M4 6v12c0 1.1.9 2 2 2h14v-4"></path>
            <circle cx="18" cy="14" r="1"></circle>
        {:else if name === 'credit-card'}
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
            <line x1="1" y1="10" x2="23" y2="10"></line>
        {:else if name === 'dollar-sign'}
            <line x1="12" y1="1" x2="12" y2="23"></line>
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
        {:else if name === 'user'}
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
        {:else if name === 'users'}
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        {:else if name === 'shield' || name === 'shield-check'}
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            <polyline points="9 12 11 14 15 10"></polyline>
        {:else if name === 'bot'}
            <rect x="3" y="11" width="18" height="10" rx="2"></rect>
            <circle cx="12" cy="5" r="2"></circle>
            <path d="M12 7v4"></path>
            <line x1="8" y1="16" x2="8" y2="16"></line>
            <line x1="16" y1="16" x2="16" y2="16"></line>
        {:else if name === 'sparkles'}
            <path d="M12 3l1.912 5.813a2 2 0 001.275 1.275L21 12l-5.813 1.912a2 2 0 00-1.275 1.275L12 21l-1.912-5.813a2 2 0 00-1.275-1.275L3 12l5.813-1.912a2 2 0 001.275-1.275L12 3z"></path>
        {:else if name === 'settings' || name === 'gear'}
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        {:else if name === 'calendar'}
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
        {:else if name === 'moon'}
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        {:else if name === 'key'}
            <path d="M21 2l-2 2m-1.5 1.5L19 7l-2 2-1.5-1.5L14 9l-2-2 1.5-1.5M10.5 10.5A6 6 0 1 0 3 18a6 6 0 0 0 7.5-7.5z"></path>
        {:else if name === 'refresh'}
            <polyline points="23 4 23 10 17 10"></polyline>
            <polyline points="1 20 1 14 7 14"></polyline>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
        {:else if name === 'trash'}
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        {:else if name === 'edit' || name === 'pencil'}
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
        {:else if name === 'eye'}
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
            <circle cx="12" cy="12" r="3"></circle>
        {:else if name === 'eye-off'}
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
            <line x1="1" y1="1" x2="23" y2="23"></line>
        {:else if name === 'table'}
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="3" y1="9" x2="21" y2="9"></line>
            <line x1="3" y1="15" x2="21" y2="15"></line>
            <line x1="12" y1="3" x2="12" y2="21"></line>
        {:else if name === 'list'}
            <line x1="8" y1="6" x2="21" y2="6"></line>
            <line x1="8" y1="12" x2="21" y2="12"></line>
            <line x1="8" y1="18" x2="21" y2="18"></line>
            <line x1="3" y1="6" x2="3.01" y2="6"></line>
            <line x1="3" y1="12" x2="3.01" y2="12"></line>
            <line x1="3" y1="18" x2="3.01" y2="18"></line>
        {:else if name === 'plus'}
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
        {:else if name === 'minus'}
            <line x1="5" y1="12" x2="19" y2="12"></line>
        {:else if name === 'zap'}
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
        {:else if name === 'send'}
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
        {:else if name === 'package' || name === 'box'}
            <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line>
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
            <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
            <line x1="12" y1="22.08" x2="12" y2="12"></line>
        {:else if name === 'star'}
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
        {:else if name === 'tag'}
            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
            <line x1="7" y1="7" x2="7.01" y2="7"></line>
        {:else if name === 'scissors'}
            <circle cx="6" cy="6" r="3"></circle>
            <circle cx="6" cy="18" r="3"></circle>
            <line x1="20" y1="4" x2="8.12" y2="15.88"></line>
            <line x1="14.47" y1="14.48" x2="20" y2="20"></line>
            <line x1="8.12" y1="8.12" x2="12" y2="12"></line>
        {:else if name === 'target'}
            <circle cx="12" cy="12" r="10"></circle>
            <circle cx="12" cy="12" r="6"></circle>
            <circle cx="12" cy="12" r="2"></circle>
        {:else if name === 'file-text'}
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
        {:else if name === 'lock'}
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        {:else if name === 'pause'}
            <rect x="6" y="4" width="4" height="16"></rect>
            <rect x="14" y="4" width="4" height="16"></rect>
        {:else if name === 'play'}
            <polygon points="5 3 19 12 5 21 5 3"></polygon>
        {:else if name === 'save'}
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
            <polyline points="17 21 17 13 7 13 7 21"></polyline>
            <polyline points="7 3 7 8 15 8"></polyline>
        {:else if name === 'copy'}
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
        {:else if name === 'lightbulb'}
            <line x1="9" y1="18" x2="15" y2="18"></line>
            <line x1="10" y1="22" x2="14" y2="22"></line>
            <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"></path>
        {:else if name === 'building'}
            <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
            <line x1="9" y1="22" x2="9" y2="12"></line>
            <line x1="15" y1="22" x2="15" y2="12"></line>
            <line x1="4" y1="12" x2="20" y2="12"></line>
        {:else if name === 'wifi'}
            <path d="M5 12.55a11 11 0 0 1 14.08 0"></path>
            <path d="M1.42 9a16 16 0 0 1 21.16 0"></path>
            <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
            <line x1="12" y1="20" x2="12.01" y2="20"></line>
        {:else if name === 'battery'}
            <rect x="1" y="6" width="18" height="12" rx="2"></rect>
            <line x1="23" y1="11" x2="23" y2="13"></line>
        {:else if name === 'alert-triangle' || name === 'warning'}
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
        {:else if name === 'book-open' || name === 'book'}
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
        {:else if name === 'award'}
            <circle cx="12" cy="8" r="7"></circle>
            <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
        {:else if name === 'shopping-bag'}
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <path d="M16 10a4 4 0 0 1-8 0"></path>
        {:else if name === 'flask'}
            <path d="M9 3h6"></path>
            <path d="M10 9l-4.5 9A2 2 0 0 0 7.3 21h9.4a2 2 0 0 0 1.8-3L14 9"></path>
            <line x1="10" y1="3" x2="10" y2="9"></line>
            <line x1="14" y1="3" x2="14" y2="9"></line>
        {:else if name === 'burger'}
            <path d="M4 11a8 8 0 0 1 16 0H4z"></path>
            <line x1="3" y1="14" x2="21" y2="14"></line>
            <rect x="4" y="17" width="16" height="4" rx="2"></rect>
        {:else if name === 'pizza'}
            <path d="M12 2l9 16a2 2 0 0 1-1.73 3H4.73A2 2 0 0 1 3 18L12 2z"></path>
            <circle cx="12" cy="12" r="1.5"></circle>
            <circle cx="9" cy="16" r="1.2"></circle>
            <circle cx="15" cy="16" r="1.2"></circle>
        {:else if name === 'coffee'}
            <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
            <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
            <line x1="6" y1="2" x2="6" y2="4"></line>
            <line x1="10" y1="2" x2="10" y2="4"></line>
            <line x1="14" y1="2" x2="14" y2="4"></line>
        {:else if name === 'ice-cream'}
            <path d="M12 2a5 5 0 0 0-5 5c0 1 .3 1.9.8 2.7L12 22l4.2-12.3c.5-.8.8-1.7.8-2.7a5 5 0 0 0-5-5z"></path>
            <path d="M7 10h10"></path>
        {:else if name === 'bowl' || name === 'acai'}
            <path d="M4 11h16a8 8 0 0 1-16 0z"></path>
            <path d="M12 3c-1.5 2-2 4-2 6h4c0-2-.5-4-2-6z"></path>
        {:else if name === 'sushi'}
            <rect x="3" y="7" width="18" height="12" rx="4"></rect>
            <circle cx="12" cy="13" r="3"></circle>
            <circle cx="12" cy="13" r="1"></circle>
        {:else if name === 'bento' || name === 'marmita'}
            <rect x="3" y="5" width="18" height="14" rx="3"></rect>
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="12" y1="12" x2="12" y2="19"></line>
        {:else if name === 'layers'}
            <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
            <polyline points="2 17 12 22 22 17"></polyline>
            <polyline points="2 12 12 17 22 12"></polyline>
        {:else if name === 'search-icon'}
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        {:else}
            <circle cx="12" cy="12" r="8"></circle>
        {/if}
    </svg>
{/if}
